import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outer-frame-product-configuration',
  templateUrl: './outer-frame-product-configuration.component.html',
  styleUrls: ['./outer-frame-product-configuration.component.scss']
})
export class OuterFrameProductCOnfigurationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
